import i18n from '@/i18n';
export default [
    {
        get text() {
            return i18n?.global?.t('tableHeaders.id');
        },
        value: 'id',
        sortable: true,
    },
    {
        get text() {
            return i18n?.global?.t('common.employeeNumber');
        },
        value: 'no',
        sortable: true,
    },
    {
        get text() {
            return i18n?.global?.t('tableHeaders.image');
        },
        value: 'photo',
    },
    {
        get text() {
            return i18n?.global?.t('tableHeaders.nameSurname');
        },
        value: 'name',
        sortable: true,
    },
    {
        get text() {
            return i18n?.global?.t('tableHeaders.email');
        },
        value: 'email',
        sortable: true,
    },
    {
        get text() {
            return i18n?.global?.t('tableHeaders.criticality');
        },
        value: 'user_criticality',
    },
    {
        get text() {
            return i18n?.global?.t('tableHeaders.phone');
        },
        value: 'phone',
    },
    {
        get text() {
            return i18n?.global?.t('tableHeaders.function');
        },
        value: 'function',
        sortable: true,
    },
    {
        get text() {
            return i18n?.global?.t('tableHeaders.department');
        },
        value: 'department',
        sortable: true,
    },
    {
        get text() {
            return i18n?.global?.t('common.crew');
        },
        value: 'crew_id',
    },
    {
        get text() {
            return i18n?.global?.t('tableHeaders.status');
        },
        value: 'status',
        sortable: true,
    },
    {
        get text() {
            return i18n?.global?.t('tableHeaders.accountStatus');
        },
        value: 'account_status',
        sortable: true,
    },
    { value: 'operation', width: 54, fixed: true },
];
